module.exports = __webpack_public_path__ + "img/shurjopay_logo.10118b23.png";